{
  "register-secret-data-page": {
    "buttons": {
      "back": "Zpět",
      "submit": "Odeslat"
    },
    "text": {
      "login-data": "Vaše přihlašovací údaje",
      "login-data-hint": "Je třeba nastavit přihlašovací údaje"
    }
  }
}
